export const CORE_WEB_VITALS_CONFIG = [
    {
        key: 'lcp',
        label: 'Largest Contentful Paint',
        shortLabel: 'LCP',
        format: 'duration',
        thresholds: { good: 2500, needsImprovement: 4000 },
        showInPreview: true
    },
    {
        key: 'cls',
        label: 'Cumulative Layout Shift',
        shortLabel: 'CLS',
        format: 'score',
        thresholds: { good: 0.1, needsImprovement: 0.25 },
        showInPreview: true
    },
    {
        key: 'ttfb',
        label: 'Time to First Byte',
        shortLabel: 'TTFB',
        format: 'duration',
        thresholds: { good: 800, needsImprovement: 1800 },
        showInPreview: true
    },
    {
        key: 'inp',
        label: 'Interaction to Next Paint',
        shortLabel: 'INP',
        format: 'duration',
        thresholds: { good: 200, needsImprovement: 500 },
        showInPreview: false
    },
    {
        key: 'fid',
        label: 'First Input Delay',
        shortLabel: 'FID',
        format: 'duration',
        thresholds: { good: 100, needsImprovement: 300 },
        showInPreview: false
    },
    {
        key: 'fcp',
        label: 'First Contentful Paint',
        shortLabel: 'FCP',
        format: 'duration',
        thresholds: { good: 1800, needsImprovement: 3000 },
        showInPreview: false
    }
];






